export default "__VITE_ASSET__DrAK41bU__"